import o from "./highrise1327.mjs";
import r from "./highrise1328.mjs";
import e from "./highrise1329.mjs";
function p(t) {
  return typeof t.constructor == "function" && !e(t) ? o(r(t)) : {};
}
export {
  p as default
};
